import React from 'react';
import { withTranslation } from 'react-i18next';
import { translate, convertToDecimal, convertToSeparator, formatData } from '../../../utils/util';

const LogListItem = (props) => {
    let jsonRequest = {};
    try {
        if (props.item.jsonRequest?.substring(0, 1) === "{") {
            jsonRequest = JSON.parse(props.item.jsonRequest);
        }
    } catch (e) {
        // Default to empty object
    }
    return (
        <div
            key={`key_${props.item.createdOn}`}
            className="collection-item"
            style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
            onClick={() => props.onClickItem(props.item)}
        >
            <div className="row" style={{ marginBottom: '0px' }}>
                <div className="col s6">
                    <div>{`${translate('physical-confirmation:mvm')}: ${convertToSeparator(props.item.mvmNumber) || ''}`}</div>
                </div>
                <div className="col s6">
                    <div>{`${translate('physical-confirmation:journey')}: ${convertToDecimal(props.item.journey) || ''}`}</div>
                </div>
                <div className="col s6">
                    <div>{`${translate('physical-confirmation:user')}: ${props.item.createdBy || ''}`}</div>
                </div>
                <div className="col s6">
                    <div>{translate('physical-confirmation:return')}: {props.item.success ? translate('physical-confirmation:success') : translate('physical-confirmation:fail')}</div>
                </div>
                <div className="col s6">
                    <b>{`${formatData(props.item.createdOn)}`}</b>
                </div>
                <div className="col s6">
                    <div>{translate('physical-confirmation:operation')}: {jsonRequest?.OPERATION}</div>
                </div>
            </div>
        </div>
    )
}

export default (withTranslation()(LogListItem));
